import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 16
}

const RadioButtonHoverIcon = props => (
    <SvgIcon keepPathColor {...props}>
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 15c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z" />
        <circle cx="8" cy="8" r="5.333" />
    </SvgIcon>
)

RadioButtonHoverIcon.defaultProps = defaultProps

export { RadioButtonHoverIcon }
